import KeepAlive, { useActivate, useUnactivate } from 'react-activation'
import { useLocation, useNavigate } from 'react-router-dom'
import styles from './index.module.less'
import { Tabs } from 'antd'
import type { TabsProps } from 'antd'
import ChatDialog from '@/pages/messageChat/ChatDialog'
import TodoList from '@/pages/messageChat/TodoList'

import { useDebounceEffect, useSetState } from 'ahooks'
import { useShallow } from 'zustand/react/shallow'
import useChatStore, { getDialogKey } from '@/store/chatStore.ts'
import { useFileUrlPrefix } from 'shj-utils'
import { useCallback, useEffect, useRef } from 'react'
import MessageList from '@/pages/messageChat/MessageList'
import { fetchMessage } from '@/pages/messageChat/service.ts'
import dayjs from 'dayjs'

export function MessageChat() {
  const [urlPrefix] = useFileUrlPrefix()
  const {
    chatState,
    setChatState,
    messageData,
    setScroll,
    messageState,
    setMessageState,
    chatSelect,
    updateTimeMap,
  } = useChatStore(
    useShallow((state: any) => ({
      chatState: state.chatState,
      setChatState: state.setChatState,
      messageData: state.messageData,
      setScroll: state.setScroll,
      messageState: state.messageState,
      setMessageState: state.setMessageState,
      chatSelect: state.chatSelect,
      updateTimeMap: state.updateTimeMap,
    }))
  )
  const chatLoading = useRef({})
  const [state, setState] = useSetState({
    inkBarAnimated: false,
  })
  const navigate = useNavigate()

  useDebounceEffect(
    () => {
      setState({
        inkBarAnimated: true,
      })
      return () => {}
    },
    [],
    { wait: 200 }
  )

  useEffect(() => {
    console.log('useEffect')
  }, [])

  useActivate(() => {
    setTimeout(() => {
      setState({
        inkBarAnimated: true,
      })
    }, 300)
  })

  useUnactivate(() => {
    setState({
      inkBarAnimated: false,
    })
  })

  const onTabChange = chatTabKey => {
    setChatState({
      chatTabKey,
    })
  }
  const onChatSelect = (d, key?) => {
    chatSelect(d, key)
  }

  const setChatLoading = (key, loading = true) => {
    chatLoading.current[key] = loading
    messageState.loading[key] = loading
    setMessageState(messageState)
  }

  const setChatNoMore = (key, noMore = true) => {
    messageState.noMore[key] = noMore
    setMessageState(messageState)
  }
  const handleScrollFrame = values => {
    setScroll(values.scrollTop)
  }

  const navigateFlow = ({ appCode, procDefKey, procInstId, flowTaskId }: any = {}) => {
    // console.log('navigateFlow', appCode, flowCode, taskId)
    navigate(
      `/flow/${appCode || ''}/${procDefKey || ''}/?taskId=${flowTaskId || ''}&procInstId=${
        procInstId || ''
      }`
    )
  }

  const chatProps = {
    urlPrefix,
    countDict: chatState.countDict,
    // active: chatState.chatActive,
    onSelect: onChatSelect,
    setChatLoading,
    setChatNoMore,
    navigateFlow,
  }

  // const items: TabsProps['items'] = [
  //   // {
  //   //   key: 'ALL',
  //   //   label: '全部',
  //   //   children: <ChatList data={getChatData({ type: 'ALL' })} {...chatProps} />,
  //   // },
  //   {
  //     key: 'MESSAGE',
  //     label: '消息',
  //     children: <MessageList {...chatProps} active={chatState.activeDict['MESSAGE']} />,
  //   },
  //   {
  //     key: 'TODO',
  //     label: '待办事项',
  //     children: (
  //       <TodoList {...chatProps} active={chatState.activeDict['TODO' + chatState.todoTabKey]} />
  //     ),
  //   },
  // ]

  const dialogKey = getDialogKey(chatState)

  const Dialog =
    {
      ['MESSAGE']: MessageList.Dialog,
      ['TODO']: TodoList.Dialog,
    }[chatState.chatTabKey] || ChatDialog

  const dialogProps = {
    dialogKey,
    urlPrefix,
    onScroll: handleScrollFrame,
    messageData: messageData[dialogKey] || [],
    lastUpdatedTime: updateTimeMap[dialogKey] || [],
    defaultScrollTop: messageState.scroll[dialogKey],
    noMore: messageState.noMore[dialogKey],
    loading: messageState.loading[dialogKey],
  }

  // console.log(chatState.chatActive, messageData, dialogKey)
  return (
    <div className={styles.chatWrap}>
      <div className={styles.chatAideList}>
        {/*<Tabs*/}
        {/*  items={items}*/}
        {/*  tabBarStyle={{ padding: '0 25px' }}*/}
        {/*  size="large"*/}
        {/*  defaultActiveKey={chatState.chatTabKey}*/}
        {/*  activeKey={chatState.chatTabKey}*/}
        {/*  onChange={onTabChange}*/}
        {/*  animated={{ inkBar: state.inkBarAnimated }}*/}
        {/*/>*/}
        <MessageList {...chatProps} active={chatState.activeDict['MESSAGE']} />
      </div>
      <Dialog {...dialogProps} />
    </div>
  )
}

const MessageChatAlive = props => {
  const location = useLocation()
  return (
    <KeepAlive name={location.pathname} id={'keep' + location.pathname}>
      <MessageChat {...props} />
    </KeepAlive>
  )
}

export default MessageChat
